import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfProgressProps {
    /**
     * 是否已进入,并进行展示
     */
    isEnter: boolean;
    /**
     * 主题色
     */
    theme?: 'gray' | 'blue' | 'green';
    /**
     * children
     */
    children?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 进度条
 */
const EfProgress: React.FC<EfProgressProps> = ({ isEnter = true, theme = 'default', className, children, ...reset }) => {
    const prefixCls = `ef-progress`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-enter`]: isEnter,
        [`${prefixCls}-${theme}`]: theme,
    });

    return (
        <div className={classes} {...reset}>
            <div className={`${prefixCls}-bar`}>
                <div className={`${prefixCls}-bar-percent`}></div>
            </div>
            <div className={`${prefixCls}-msg`}>{children}</div>
        </div>
    );
};

export default EfProgress;
